// Assuming you have stimulus already set up in your application
import { Controller } from "@hotwired/stimulus"

import Sortable from "sortablejs"


export default class extends Controller {
    static values = { updateUrl: String }

    connect() {
        this.sortable = Sortable.create(this.element, {
            animation: 150,
            onEnd: this.end.bind(this),
        });
    }

    disconnect() {
        this.sortable?.destroy();
        this.sortable = null;
    }

    end(event) {
        let itemEls = [...this.element.querySelectorAll('.sortable-item')];
        let order = itemEls.map(item => item.dataset.itemId);
        this.updateOrder(order);
    }

    updateOrder(order) {
        fetch(this.updateUrlValue, {
            method: 'PATCH',
            headers: {
                "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ order: order }) // Ensure this matches what your Rails action expects
        }).then(response => {
            if (response.ok) {
                console.log("Order updated");
            } else {
                console.error("Error updating order");
                response.json().then(data => console.error(data)); // Log the server response to help debug
            }
        });
    }

}
